import * as ko from "knockout";
import * as _ from "lodash";
import * as AppointmentData from "../data/appointmentData";
import * as UI from "./ui";

// ==================================================================
// dialog for adding a new form
// ==================================================================
interface IAddFormDialogViewModel {
    ListName: KnockoutObservable<string>;
    TemplateFormID: KnockoutObservable<number>;
    ID: KnockoutObservable<number>;
    // if true, the user must pick from a list of template forms
    MultipleTemplateFormIDs: KnockoutObservable<boolean>;

    // used if multiple template forms are available, the list of forms
    ListItems: KnockoutObservableArray<AppointmentData.IAppointmentListItem>;

    // used if only one template form is available, displays its name
    TemplateFormListName: KnockoutObservable<string>;

    // error messages
    ListNameMissing: KnockoutObservable<boolean>;
    TemplateFormIDMissing: KnockoutObservable<boolean>;

    onAddForm: () => void;
}

export class AddFormDialog {
    // private properties
    private viewModel: IAddFormDialogViewModel;

    // hTML container for the dialog
    private container: JQuery;
    private onAddForm: (listName: string, templateFormID: number, ID: number) => void;

    // constructor
    constructor() {
        const me: AddFormDialog = this;

        this.viewModel = {
            ListName: ko.observable<string>(),
            TemplateFormID: ko.observable<number>(),
            ID: ko.observable<number>(),
            ListItems: ko.observableArray<AppointmentData.IAppointmentListItem>(),
            MultipleTemplateFormIDs: ko.observable<boolean>(false),
            ListNameMissing: ko.observable<boolean>(false),
            TemplateFormIDMissing: ko.observable<boolean>(false),
            TemplateFormListName: ko.observable<string>(),
            onAddForm(): void {
                if (me.isValid()) {
                    me.container.modal("hide");
                    me.onAddForm(me.viewModel.ListName(), me.viewModel.TemplateFormID(), me.viewModel.ID());
                }
            },

        };
        // subscribe to changes in drop down to display additional form if field has exception form = true
        this.viewModel.ID.subscribe((data: any) => {
            if (me.viewModel.ListItems().length > 0) {
                const match: any = ko.utils.arrayFirst(me.viewModel.ListItems(),
                    (item: AppointmentData.IAppointmentListItem): boolean => {
                        return item.ID === data;
                    });
                me.viewModel.TemplateFormID(match.TemplateFormID);
            }

        });
    }

    public render(container: JQuery): void {
        this.container = container.find("div[data-id='newFormDialog']");
        ko.applyBindings(this.viewModel, this.container[0]);
    }

    public show(listItems: AppointmentData.IAppointmentListItem[],
                onAddForm: (listName: string, templateFormID: number, ID: number) => void): void {
        const me: AddFormDialog = this;

        if (listItems.length === 0) {
            // this should never happen if the rest of the page is designed correctly.
            UI.showErrorMessage(["No forms can be added under this item."]);
            return;
        }
        this.onAddForm = onAddForm;

        this.viewModel.ListItems.removeAll();
        _.forEach(listItems, (listItem: AppointmentData.IAppointmentListItem) => {
            me.viewModel.ListItems.push(listItem);
        });

        if (listItems.length === 1) {
            // single item, do not display drop down
            this.viewModel.MultipleTemplateFormIDs(false);
            this.viewModel.TemplateFormID(listItems[0].TemplateFormID);
            this.viewModel.TemplateFormListName(listItems[0].ListItemName);
        } else {
            // have user pick form
            this.viewModel.MultipleTemplateFormIDs(true);

            this.viewModel.ListItems.unshift({
                ID: 0,
                TemplateFormID: 0,
                ParentID: 0,
                ListItemName: "(select form template)",
                SortOrder: 0,
            });
        }

        this.viewModel.ListName("");

        this.viewModel.ListNameMissing(false);
        this.viewModel.TemplateFormIDMissing(false);

        // show the bootstrap dialog
        this.container.modal("show");
    }

    private isValid(): boolean {
        let isValid: boolean = true;

        isValid = UI.setRequiredString(this.viewModel.ListName, this.viewModel.ListNameMissing) ? isValid : false;
        isValid = UI.setRequiredNumber(this.viewModel.ID, this.viewModel.TemplateFormIDMissing, true) ? isValid : false;

        return isValid;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/addFormDialog.ts